export const tag = (x) => x;
//# sourceMappingURL=util.js.map